export interface DemoEmail {
  id: string;
  from: string;
  subject: string;
  time: string;
  isSpam: boolean;
  score?: number;
  scoreLabel?: string;
  reasons?: string[];
  folder?: string;
}

export interface DemoFolder {
  name: string;
  color: string;
  bgColor: string;
  borderColor: string;
}

// Emails for the scoring demo — mix of spam and legit
export const scoringEmails: DemoEmail[] = [
  {
    id: 'score-1',
    from: 'Jake Morrison',
    subject: 'Quick question about your growth strategy',
    time: '10:32 AM',
    isSpam: true,
    score: 87,
    scoreLabel: 'Cold Outreach',
    reasons: ['Generic greeting', 'No prior relationship', 'Sales language'],
  },
  {
    id: 'score-2',
    from: 'Sarah Chen',
    subject: 'Re: Q2 planning doc feedback',
    time: '10:28 AM',
    isSpam: false,
  },
  {
    id: 'score-3',
    from: 'Mike at LeadBoost',
    subject: "I'd love to show you how we help teams like yours",
    time: '10:15 AM',
    isSpam: true,
    score: 92,
    scoreLabel: 'Cold Outreach',
    reasons: ['Unsolicited pitch', 'Template language', 'No prior contact'],
  },
  {
    id: 'score-4',
    from: 'Alice Park',
    subject: 'Lunch tomorrow?',
    time: '9:58 AM',
    isSpam: false,
  },
  {
    id: 'score-5',
    from: 'BDR Team @ ScaleUp',
    subject: 'Congrats on the funding — let me help you spend it',
    time: '9:41 AM',
    isSpam: true,
    score: 95,
    scoreLabel: 'Cold Outreach',
    reasons: ['Scraped news trigger', 'Aggressive CTA', 'No relationship'],
  },
];

// Folders for the routing demo
export const demoFolders: DemoFolder[] = [
  {
    name: 'Important',
    color: 'text-blue-400',
    bgColor: 'bg-blue-500/10',
    borderColor: 'border-blue-500/20',
  },
  {
    name: 'Finance',
    color: 'text-green-400',
    bgColor: 'bg-green-500/10',
    borderColor: 'border-green-500/20',
  },
  {
    name: 'Newsletters',
    color: 'text-purple-400',
    bgColor: 'bg-purple-500/10',
    borderColor: 'border-purple-500/20',
  },
  {
    name: 'Cold Outreach',
    color: 'text-red-400',
    bgColor: 'bg-red-500/10',
    borderColor: 'border-red-500/20',
  },
];

// Emails for the routing demo
export const routingEmails: DemoEmail[] = [
  {
    id: 'route-1',
    from: 'CFO Office',
    subject: 'Q2 budget approval needed',
    time: '11:02 AM',
    isSpam: false,
    folder: 'Finance',
  },
  {
    id: 'route-2',
    from: 'TechCrunch Daily',
    subject: 'Top stories: AI funding hits record high',
    time: '10:45 AM',
    isSpam: false,
    folder: 'Newsletters',
  },
  {
    id: 'route-3',
    from: 'Your Manager',
    subject: 'Urgent: client escalation — need your input',
    time: '10:30 AM',
    isSpam: false,
    folder: 'Important',
  },
  {
    id: 'route-4',
    from: 'Alex at GrowthHQ',
    subject: 'Saw your LinkedIn post — let me help scale your team',
    time: '10:12 AM',
    isSpam: true,
    folder: 'Cold Outreach',
  },
  {
    id: 'route-5',
    from: 'Stripe',
    subject: 'Your January invoice is ready',
    time: '9:55 AM',
    isSpam: false,
    folder: 'Finance',
  },
];

// Messy inbox for the before/after demo
export const messyInboxEmails: DemoEmail[] = [
  {
    id: 'messy-1',
    from: 'Jake Morrison',
    subject: 'Quick sync on your pipeline?',
    time: '10:32 AM',
    isSpam: true,
  },
  {
    id: 'messy-2',
    from: 'Sarah Chen',
    subject: 'Re: Q2 planning doc',
    time: '10:28 AM',
    isSpam: false,
  },
  {
    id: 'messy-3',
    from: 'Growth Tools Inc',
    subject: 'Your free trial is waiting',
    time: '10:22 AM',
    isSpam: true,
  },
  {
    id: 'messy-4',
    from: 'Alice Park',
    subject: 'Lunch tomorrow?',
    time: '10:15 AM',
    isSpam: false,
  },
  {
    id: 'messy-5',
    from: 'SDR @ CloudScale',
    subject: "I noticed you're hiring — we can help",
    time: '10:08 AM',
    isSpam: true,
  },
  {
    id: 'messy-6',
    from: 'Jira',
    subject: '[PROJ-442] Bug fix merged',
    time: '10:01 AM',
    isSpam: false,
  },
  {
    id: 'messy-7',
    from: 'BDR Team',
    subject: 'Congrats on Series A!',
    time: '9:55 AM',
    isSpam: true,
  },
  {
    id: 'messy-8',
    from: 'Your Manager',
    subject: 'Urgent: client needs response today',
    time: '9:48 AM',
    isSpam: false,
  },
  {
    id: 'messy-9',
    from: 'LeadGen Pro',
    subject: 'Book 50 meetings/month on autopilot',
    time: '9:41 AM',
    isSpam: true,
  },
  {
    id: 'messy-10',
    from: 'Stripe',
    subject: 'Your January invoice',
    time: '9:34 AM',
    isSpam: false,
  },
  {
    id: 'messy-11',
    from: 'Outreach AI',
    subject: "Let's scale your sales team",
    time: '9:27 AM',
    isSpam: true,
  },
  {
    id: 'messy-12',
    from: 'Google Calendar',
    subject: 'Reminder: team standup in 30 min',
    time: '9:20 AM',
    isSpam: false,
  },
  {
    id: 'messy-13',
    from: 'Mike at SellFast',
    subject: 'Quick question about your tech stack',
    time: '9:13 AM',
    isSpam: true,
  },
  {
    id: 'messy-14',
    from: 'HR',
    subject: 'Benefits enrollment reminder',
    time: '9:06 AM',
    isSpam: false,
  },
  {
    id: 'messy-15',
    from: 'PipelinePro',
    subject: "You're leaving revenue on the table",
    time: '8:59 AM',
    isSpam: true,
  },
];

// Clean inbox (after filtering) — just the non-spam emails with folder labels
export const cleanInboxEmails: DemoEmail[] = messyInboxEmails
  .filter((e) => !e.isSpam)
  .map((e) => ({
    ...e,
    folder:
      e.from === 'Your Manager'
        ? 'Important'
        : e.from === 'Stripe'
          ? 'Finance'
          : e.from === 'Jira'
            ? 'Important'
            : e.from === 'Google Calendar'
              ? 'Important'
              : e.from === 'HR'
                ? 'Important'
                : e.from === 'Sarah Chen'
                  ? 'Important'
                  : e.from === 'Alice Park'
                    ? 'Important'
                    : undefined,
  }));
